export default {
    name: 'navigation',
    props: ['baseUrl'],
    data() {
        return {
            firstLevel: "level-1",
            secondLevel: "level-2",
            firstLevelFirstEl: "level-1 first",
            secondLevelFirstEl: "level-2 first",
            firstLevelLastEl: "level-1 last",
            secondLevelLastEl: "level-2 last",
        }
    },
    methods: {
        createPathWithOldSiteUrl: function (path) {
            return "http://www.old.triathlonireland.com" + path;
        },
        createUrl: function (path) {
            return this.baseUrl + path;
        }        
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/navigation/navigation.js